import { CREATE_ALLOCATOR_NETWORKS_FAILED, CREATE_ALLOCATOR_NETWORKS_INIT, CREATE_ALLOCATOR_NETWORKS_SUCCESS, DELETE_ALLOCATOR_NETWORKS_FAILED, DELETE_ALLOCATOR_NETWORKS_INIT, DELETE_ALLOCATOR_NETWORKS_SUCCESS, GET_ALLOCATOR_NETWORKS_FAILED, GET_ALLOCATOR_NETWORKS_INIT, GET_ALLOCATOR_NETWORKS_SUCCESS, GET_ALLOCATOR_NETWORK_STATS_FAILED, GET_ALLOCATOR_NETWORK_STATS_INIT, GET_ALLOCATOR_NETWORK_STATS_SUCCESS, GET_ALLOCATOR_USERS_FAILED, GET_ALLOCATOR_USERS_INIT, GET_ALLOCATOR_USERS_SUCCESS, GET_INVESTOR_TYPE_FAILED, GET_INVESTOR_TYPE_INIT, GET_INVESTOR_TYPE_SUCCESS, UPDATE_ALLOCATOR_NETWORKS_FAILED, UPDATE_ALLOCATOR_NETWORKS_INIT, UPDATE_ALLOCATOR_NETWORKS_SUCCESS } from "./constants";

export const initialState = {
  loading: false,
  anLoading: false,
  userLoading: false,
  allocatorNetworks: [],
  investorTypes: [],
  networkStats: {},
  allocatorUsers: [],
  currentPage: 0,
  perPage: 8,
  totalPages: 0
};

export default function allocatorNetwork(state = initialState, action) {
  switch (action.type) {
    case GET_ALLOCATOR_NETWORKS_INIT:
      return { ...state, anLoading: true, };
    case GET_ALLOCATOR_NETWORKS_SUCCESS:
      return {
        ...state,
        totalPages: action.payload.pages,
        currentPage: action.payload.page,
        allocatorNetworks: action.payload.page === 1
          ? [...action.payload.items]
          : [...state.allocatorNetworks, ...action.payload.items],
        anLoading: false,
      };
    case GET_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, anLoading: false };

    case GET_ALLOCATOR_NETWORK_STATS_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATOR_NETWORK_STATS_SUCCESS:
      return {
        ...state,
        networkStats: action.payload,
        loading: false,
      };
    case GET_ALLOCATOR_NETWORK_STATS_FAILED:
      return { ...state, loading: false };

    case CREATE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case CREATE_ALLOCATOR_NETWORKS_SUCCESS:
      const result = state.allocatorNetworks;
      const status = state.networkStats;
      const indexValue = [...result].findIndex((network) => action.payload?.receiverId === network.id);
      if (indexValue !== -1) {
        result[indexValue].recieverNetwork = action.payload;
        status.requestSent = status?.requestSent + 1;
      }
      return {
        ...state,
        allocatorNetworks: result,
        loading: false,
      };
    case CREATE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };

    case UPDATE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case UPDATE_ALLOCATOR_NETWORKS_SUCCESS:
      const allocator = state.allocatorNetworks;
      const networkStatus = state.networkStats;
      const index = [...allocator].findIndex((network) => action.payload?.senderId === network.id);
      if (index !== -1) {
        allocator[index].senderNetwork = action.payload;
        if (allocator[index].senderNetwork.status === 1) {

          networkStatus.myConnection = networkStatus?.myConnection + 1;
          networkStatus.request = networkStatus?.request - 1;

        } else if (allocator[index].senderNetwork.status === 2) {

          networkStatus.request = networkStatus?.request - 1;
        } else {

          networkStatus.blocked = networkStatus.blocked + 1;
          if (allocator[index].senderNetwork.status === 1) {

            networkStatus.myConnection = networkStatus?.myConnection - 1;
          } else if (allocator[index].senderNetwork.status === 2) {

            networkStatus.requestSent = networkStatus?.requestSent - 1;
          } else if (allocator[index].senderNetwork.status === 0) {

            networkStatus.request = networkStatus?.request - 1;
          }
        }
      }
      return {
        ...state,
        allocatorNetworks: allocator,
        loading: false,
      };
    case UPDATE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };

    case GET_INVESTOR_TYPE_INIT:
      return { ...state, loading: true };
    case GET_INVESTOR_TYPE_SUCCESS:
      return {
        ...state,
        investorTypes: action.payload,
        loading: false,
      };
    case GET_INVESTOR_TYPE_FAILED:
      return { ...state, loading: false };

    case DELETE_ALLOCATOR_NETWORKS_INIT:
      return { ...state, loading: true };
    case DELETE_ALLOCATOR_NETWORKS_SUCCESS:
      const allocators = state.allocatorNetworks;
      const statuss = state.networkStats;

      const i = [...allocators].findIndex((item) => action.payload === (item.recieverNetwork !== null ? item.recieverNetwork?.id : item.senderNetwork?.id));
      if (i !== -1) {
        allocators[i].recieverNetwork = null;
        statuss.requestSent = statuss.requestSent - 1;
      }
      return {
        ...state,
        allocatorNetworks: allocators,
        loading: false,
      };
    case DELETE_ALLOCATOR_NETWORKS_FAILED:
      return { ...state, loading: false };
    case GET_ALLOCATOR_USERS_INIT:
      return { ...state, allocatorUsers:[],userLoading: true };
    case GET_ALLOCATOR_USERS_SUCCESS:
      return {
        ...state,
        allocatorUsers: action.payload,
        userLoading: false,
      };
    case GET_ALLOCATOR_USERS_FAILED:
      return { ...state, userLoading: false };

    default:
      return state;
  }
}
